<template>
    <el-dialog class="dialog dialog-mini" :visible="dialogs.orkRename" customClass="dialog_main dialog-mini_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Редактирование отраслевой рамки квалификаций</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form class="search-form" @submit.prevent="submitSelected">
                <div class="dialog__content">
                    <validate-input v-model="orkName" placeholder="Название отраслевой рамки" v-bind:error="orkNameError" v-on:update:error="orkNameError = $event" :validateOptions="['empty']"/>
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item">
                            <button type="button" class="btn" @click="closeDialog">Отменить</button>
                        </div>

                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action" :disabled="!orkName.length || orkNameError">Применить</button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

export default {
    mixins: [ dialog ],
    components: {
        ValidateInput
    },
    props: {
        curOrk: {
            type: Object,
            default: function() {
                return {}
            }
        }  
    },
    data() {
        return {
            orkName: '',
            orkNameError: false
        }
    },
    methods: {
        ...mapActions('ork', ['EDIT_ORK']),
        ...mapMutations('common', ['TOGGLE_ALERT']),

        closeDialog() {
            this.orkName = ''
            this.orkNameError = false

            this.elDialogs.orkRename = false;
        },
        handleOpen() {
            this.orkName = this.curOrk.name
        },
        async submitSelected() {
            if (this.orkList.find(el => el.name === this.orkName && el.id !== this.curOrk.id)) {
                this.orkNameError = true
                this.TOGGLE_ALERT({open: true, text: 'Введите уникальное название ОРК'})
            } else {
              console.log(this.curOrk.id);
                const id = this.curOrk.id
                const params = { name: this.orkName }
                this.EDIT_ORK({
                    id,
                    params
                })
    
                this.closeDialog()
            }
        }
    },
    computed: {
        ...mapState('ork', ['orkList'])
    }
}
</script>
